import { Common } from '@stockbit/ui';
import React from 'react';
import { SelectDateWrapper } from './styled';

const { Text } = Common;

interface SelectDateProps {
  label?: string;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  onChange?: (val: any) => any;
  [key: string]: any
}

const SelectDate = React.memo(
  ({ label, children, className, disabled, onChange, ...props }: SelectDateProps) => (
    <SelectDateWrapper className={className} disabled={disabled}>
      <Text as="label">{label}</Text>
      <select
        {...props}
        onChange={onChange}
        disabled={disabled}
        style={{ height: '28px' }}
      >
        {children}
      </select>
    </SelectDateWrapper>
  ),
);

export default SelectDate;
